// Standard men's sneaker sizing: foot length (cm) -> EU size.
// Matches the size dropdown options on the product (36 to 46).
const CM_TO_EU_SIZE = [
  { cm: 22.5, eu: 36 },
  { cm: 23.5, eu: 37 },
  { cm: 24, eu: 38 },
  { cm: 24.5, eu: 39 },
  { cm: 25.5, eu: 40 },
  { cm: 26, eu: 41 },
  { cm: 26.5, eu: 42 },
  { cm: 27.5, eu: 43 },
  { cm: 28, eu: 44 },
  { cm: 29, eu: 45 },
  { cm: 29.5, eu: 46 },
];

function nearestSize(cm) {
  let closest = CM_TO_EU_SIZE[0];
  let smallestDiff = Math.abs(cm - closest.cm);

  for (const entry of CM_TO_EU_SIZE) {
    const diff = Math.abs(cm - entry.cm);
    if (diff < smallestDiff) {
      smallestDiff = diff;
      closest = entry;
    }
  }

  return closest.eu;
}

class SizeRecommender extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('[ref="slider"]');
    this.cmValue = this.querySelector('[ref="cmValue"]');
    this.result = this.querySelector('[ref="result"]');
    this.brand = this.dataset.brand || '';

    if (!this.slider) return;

    this.slider.addEventListener('input', () => this.update());
    this.update();
  }

  update() {
    const cm = parseFloat(this.slider.value);
    const size = nearestSize(cm);

    if (this.cmValue) this.cmValue.textContent = `${cm} cm`;
    if (this.result) {
      this.result.textContent = this.brand
        ? `Te recomendamos talla ${size} en ${this.brand}`
        : `Te recomendamos talla ${size}`;
    }
  }
}

customElements.define('size-recommender', SizeRecommender);
